import { AxiosResponse } from "axios";
import { getRequest } from "services/client/request";
import { UserResponse, User } from "types/User";
import { postRequestWithoutToken } from "../client/request";
import { LoginRequest } from "types/User";
import { NewUser } from "types/Authentication";

const apiVersion = "/api/v1";

export const login = async (
  loginCredentials: LoginRequest
): Promise<UserResponse> => {
  try {
    const response: AxiosResponse<UserResponse> = await postRequestWithoutToken(
      `${apiVersion}/business/auth `,
      loginCredentials
    );
    return response.data;
  } catch (e) {
    console.error(e);
    return {} as UserResponse;
  }
};

export const getUserDetail = async (
  accessToken: string
): Promise<User | undefined> => {
  try {
    const response: AxiosResponse<User> = await getRequest(
      `${apiVersion}/user/profile`,
      accessToken
    );
    const userDetails: User = response.data ? response.data : ({} as User);
    return userDetails;
  } catch (e) {
    console.error(e);
  }
};

export const signUp = async (signUpRequest: NewUser): Promise<UserResponse> => {
  const response: AxiosResponse<UserResponse> = await postRequestWithoutToken(
    `${apiVersion}/register`,
    signUpRequest
  );
  const userResponse: UserResponse = response.data
    ? response.data
    : ({} as UserResponse);
  return userResponse;
};

export const forgetPassword = async (email: string): Promise<void> => {
  await postRequestWithoutToken(`${apiVersion}/forgot`, email);
};
